import React, { FC } from 'react';
import Page, { PageProps } from '@layout/page/Page';
import { Card, Stack } from '@mantine/core';
import { rgba } from 'polished';
import SimpleCard from '@shared/components/list/card/SimpleCard';
import { IconAddressBook, IconBook2, IconFileAnalytics } from '@tabler/icons-react';
import { Report } from '@modules/reports/model';

const InputReportListPage: FC = () => {
  const pageProps: PageProps = {
    seoTitle: 'Rapports intrants',
    back: {
      to: '/',
      title: 'Rapports intrants',
    },
  };

  return (
    <Page {...pageProps} withNav>
      <Card p="lg" withBorder={false} sx={theme => ({ background: rgba(theme.colors.blue[2], 0.15) })}>
        <Stack>
          <SimpleCard
            to={Report.Code.Input}
            icon={IconFileAnalytics}
            title={Report.pageTitle[Report.Code.Input]}
            sx={theme => ({ background: rgba(theme.colors.blue[9], 0.85) })}
          />
          <SimpleCard
            bg="#2363a4"
            to={Report.Code.InputBook}
            icon={IconBook2}
            title={Report.pageTitle[Report.Code.InputBook]}
          />
          <SimpleCard
            bg="blue.7"
            to={Report.Code.InterventionBook}
            icon={IconAddressBook}
            title={Report.pageTitle[Report.Code.InterventionBook]}
          />
        </Stack>
      </Card>
    </Page>
  );
};

export default InputReportListPage;
